import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {hideOptionErrors} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .options[data-option-type="selectable"] input[name="chainPosition"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);

    dispatchCustomEvent(
        'productChainPositionChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement
        }
    );
    offcanvas.querySelectorAll('.chain-position.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    hideOffcanvas(offcanvas.id);
    hideOptionErrors(offcanvas);
    trackProductPageGa4Events('BlindChain', element.dataset.preview);
});